import axiosInstance from './axiosInstance';

export const getPlans = () => axiosInstance.get('/plans');
export const subscribe = (planId) => axiosInstance.post('/plans/subscribe', { planId });
